import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useBatchList(params) {
  return useSWR(
    params?.warehouse
      ? {
          path: `/api/v1/batches`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useBatchList;
